import { Workbook } from "../interface";
import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getWorkbook(id: number): Promise<Workbook | null> {
    if (api.clientApi) {
        return api.clientApi.clientWorkbookRead(store.db ? store.db : "", id).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
            return response as unknown as Workbook;
        });
    } else {
        return null;
    }
}

export { getWorkbook };
